import styled, { css } from "styled-components";

export const Input = styled.input`
    font-weight: bold;
    border-radius: 4px;
    padding: -0.5rem;
`
export const Button = styled.button`
    margin-bottom: 10px;
    border: 2px solid;
    border-color: black;
`